/* eslint-disable no-useless-catch */
import AxiosAPI from '../../../utils/AxiosAPI';

// Get a
export const ApiGetAccessTokenList = async () => {
    try {
        const response = await AxiosAPI().setPath('/api/api-access-token').get();

        if (response.data.status !== 0) {
            throw new Error(response.data.title);
        }

        return response.data;
    } catch (ex) {
        throw ex;
    }
};

// Create New Token
export const ApiCreateNewAccessToken = async (formData, setIsError) => {
    try {
        const response = await AxiosAPI().setPath('/api/api-access-token').post(formData);

        if (response.data.status !== 0) {
            setIsError(response.data.referenceName);
            throw new Error(response.data.title);
        }

        return response.data;
    } catch (ex) {
        throw ex;
    }
};

// Delete Access Token
export const ApiDeleteAccessToken = async (id) => {
    try {
        const response = await AxiosAPI()
            .setPath(`/api/api-access-token/${id}/delete`)
            .delete({ Id: id });

        if (response.data.status !== 0) {
            throw new Error(response.data.title);
        }

        return response.data;
    } catch (ex) {
        throw ex;
    }
};
export default null;
